/* tslint:disable */
import icon from 'vue-svgicon'
icon.register({
  'delete': {
    width: 14,
    height: 14,
    viewBox: '0 0 14 14',
    data: `<defs><clipPath id="svgicon_delete_b"><path pid="0" _fill="none" d="M0 0h14v14H0z"/></clipPath><clipPath id="svgicon_delete_a"><path pid="1" d="M0 0h14v14H0z"/></clipPath></defs><g clip-path="url(#svgicon_delete_a)"><g clip-path="url(#svgicon_delete_b)" _fill="none" _stroke="currentColor" stroke-width="2"><path pid="2" d="M.707.707l12.586 12.586M13.293.707L.707 13.293"/></g></g>`
  }
})
/* tslint:enable */
